import React from 'react';
import PropTypes from "prop-types";
import {Alert} from "reactstrap";
import TecRmiBuyAccessModal from "./TecRmiBuyAccessModal";
import {useTranslation} from "react-i18next";
import getWorkshopCurrentPlanSettings from "../../utils/getWorkshopCurrentPlanSettings";
import {TCD_VEHICLE_TYPE_CAR} from "./TecRmiVehicleTypeSuppliers";

const TecRmiModuleDemoAlert = (props) => {
  const { t } = useTranslation('tec_rmi_module_demo_alert');
  const tecRmiType = (props.showType === TCD_VEHICLE_TYPE_CAR) ? getWorkshopCurrentPlanSettings('tecRmiTypeCar') : getWorkshopCurrentPlanSettings('tecRmiTypeTruck')

  if(!!tecRmiType.accountName){
    if(!tecRmiType.isActive){
      return <Alert className="d-flex flex-row flex-nowrap align-items-start" color="danger">
        <i className="fas fa-exclamation-triangle fa-2x mr-3" />
        <div className="w-100">
          <span dangerouslySetInnerHTML={{__html: t('access_expired', {typeName: t(`type_name_${props.showType}`)})}} />
          <div className="py-3">
            <TecRmiBuyAccessModal showType={props.showType} />
          </div>
        </div>
      </Alert>
    }
    return null
  }

  return <Alert className="d-flex flex-row flex-nowrap align-items-start" color="warning">
    <i className="fas fa-exclamation-triangle fa-2x mr-3" />
    <div className="w-100">
      <span dangerouslySetInnerHTML={{__html: t('access_demo', {typeName: t(`type_name_${props.showType}`)})}} />
      <div className="py-3">
        <TecRmiBuyAccessModal showType={props.showType}  showDemoRequestButton={true}/>
      </div>
    </div>
  </Alert>
};

TecRmiModuleDemoAlert.propTypes = {
  tecRmiType: PropTypes.shape({
    accountName: PropTypes.string,
    isActive: PropTypes.bool.isRequired,
  }).isRequired,
};

export default TecRmiModuleDemoAlert;